import { createApiActions, ApiActions } from "../../../shared/store/actions";
import { ASSIGNMENTS } from "../../../shared/constants";

export const ASSIGNMENT_API_ACTIONS: ApiActions = createApiActions(ASSIGNMENTS);

export const getAssignments = () => ({
  type: ASSIGNMENT_API_ACTIONS.READ
});
